import * as yup from 'yup';
import i18n from 'i18next';

const schema = yup
  .object({
    // client_name: yup.string().required(() => i18n.t('auth.required')),
    ClientNameInPO: yup.string().required(() => i18n.t('auth.required')),
    PriceOfferSentTo: yup.string().required(() => i18n.t('auth.required')),
    // client_type: yup.string().required(() => i18n.t('auth.required')),
    // Industry_Name: yup.string().required(() => i18n.t('auth.required')),
    // Client_Address: yup.string().required(() => i18n.t('auth.required')),
  })
  .required();

export default schema;
